import { useEffect } from "react";
import { hashHref } from "../constants/site";

function DocPage({ eyebrow, title, lede, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <article className="relative overflow-hidden bg-white text-navy" aria-labelledby="doc-heading">
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div className="absolute inset-0 bg-[radial-gradient(70%_50%_at_0%_0%,rgba(255,191,24,0.1),transparent_55%),radial-gradient(50%_40%_at_100%_20%,rgba(79,72,236,0.06),transparent_50%)]" />
        <div
          className="absolute inset-0 opacity-[0.3]"
          style={{
            backgroundImage: "radial-gradient(rgba(12,31,27,0.08) 1px, transparent 1px)",
            backgroundSize: "26px 26px",
          }}
        />
      </div>

      <div className="relative mx-auto max-w-3xl px-4 pb-20 pt-28 sm:px-6 lg:px-8 lg:pb-28 lg:pt-32">
        <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-navy/40">{eyebrow}</p>
        <h1
          id="doc-heading"
          className="mt-4 font-semibold leading-[1.08] tracking-tight text-navy [font-size:clamp(2rem,5vw,3.25rem)]"
        >
          {title}
        </h1>
        {lede ? <p className="mt-5 text-base leading-relaxed text-navy/60 sm:text-lg">{lede}</p> : null}
        <div className="mt-10 space-y-8 text-[15px] leading-relaxed text-navy/70 sm:text-base">{children}</div>
        <a
          href={hashHref("contact")}
          className="mt-12 inline-flex min-h-12 items-center rounded-full bg-gold px-6 text-sm font-semibold text-navy transition hover:bg-[#ffd056] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royal focus-visible:ring-offset-2"
        >
          Contact Us
        </a>
      </div>
    </article>
  );
}

export default DocPage;
